import { useMemo } from "react"

import {
  RootState,
  selectHasLoadedWalletBalances,
  selectIsConnected,
  selectMezoTokens,
  selectMezoWalletBalances,
  selectTokenBalance,
  useDappSelector,
} from "#/redux-state"

import OverviewBridgedAssetsItem from "./OverviewBridgedAssetsItem"
import OverviewSection from "./OverviewSection"

export default function OverviewBridgedAssets() {
  const isConnected = useDappSelector(selectIsConnected)
  const mezoTokens = useDappSelector(selectMezoTokens)
  const mezoTokensBalances = useDappSelector(selectMezoWalletBalances)
  const assetsLoaded = useDappSelector(selectHasLoadedWalletBalances)

  const musdBalance = useDappSelector((state: RootState) =>
    selectTokenBalance(state, "MUSD"),
  )

  const mezoTokensToDisplay = useMemo(
    () => mezoTokens.filter((token) => token !== "MUSD"),
    [mezoTokens],
  )

  const hasMezoAssets = useMemo(() => {
    const balance = Object.values(mezoTokensBalances)
      .map((token) => token.balance)
      .reduce((a, b) => a + b, 0n)

    const balanceWithoutMusd = balance - musdBalance

    return balanceWithoutMusd > 0n
  }, [mezoTokensBalances, musdBalance])

  if (!isConnected || (!hasMezoAssets && assetsLoaded)) return null

  return (
    <OverviewSection header="Assets" isLoading={!assetsLoaded}>
      {mezoTokensToDisplay.map((token) => (
        <OverviewBridgedAssetsItem key={token} token={token} />
      ))}
    </OverviewSection>
  )
}
